module.exports = __webpack_public_path__ + "img/full-setup.77b762dd.png";